// Mass Storage bolt-kit packaging.
//
// Unlike MMS, MS bolts are physically identical whether "shared" between two
// shelves or "solo", so the shared/solo split that getHardwareCount() returns is
// collapsed into a single total for MS. That total is then split across the two
// purchasable pack sizes: a 4-pack (RA0414) and a 16-pack (RA3615, = four 4-packs).

// The count shape getHardwareCount() returns. Fields are optional here because the
// value is read off untyped BuyRequest metadata at the call sites.
type BoltKitCount = { shared?: number; solo?: number }

export type MsBoltPackCount = {
  fourPack: number
  sixteenPack: number
}

// Total number of 4-bolt kits needed, ignoring the shared/solo split MS no longer
// uses. Mirrors the shared + solo sum rhpa-footer.vue historically computed as its
// same-SKU workaround.
export function getTotalBoltKitCount(hardwareCount: BoltKitCount | undefined | null): number {
  if (!hardwareCount) return 0

  return (hardwareCount.shared ?? 0) + (hardwareCount.solo ?? 0)
}

// Split the total 4-bolt-kit count into 4-pack / 16-pack quantities. Every full
// group of four 4-packs becomes one 16-pack; the remainder ships as loose 4-packs.
// Exact split — no surplus hardware.
export function getMsBoltPackCount(hardwareCount: BoltKitCount | undefined | null): MsBoltPackCount {
  const total = getTotalBoltKitCount(hardwareCount)

  return {
    fourPack    : total % 4,
    sixteenPack : Math.floor(total / 4),
  }
}
